import React, { useState, useMemo, useEffect } from 'react';

//Components
import { Button, Badge, Modal } from 'react-bootstrap';
import ModalCreateNewClient from '../PaymentPost/ModalCreateNewClient';
import LoadingAlert from '../Alerts/LoadingAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import AlertSmall from '../Alerts/AlertSmall';
import NewAddressForm from '../PaymentPost/Maps/NewAddressFrom';
import ModalViewLocation from '../PaymentPost/Maps/ModalViewLocation';
import { ClearPhone } from '../../utils/ClearPhone';
import { AuthDgiFetchAPI } from '../../api/Paymentpost/AuthDgi';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';

//libraries
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import moment from 'moment-timezone';
import './styles.css';
//Apis
import { ClientsFetchAPI } from '../../api/Clients';
import { OrdersFetchAPI } from '../../api/Orders';
import ModalParthners from '../Modals/Parthners/ModalParthners';
import ModalQuoteDetails from '../PaymentPost/ModalQuoteDetails';
import Swal from 'sweetalert2';

export default function ClientPillCard({ dataClientSelected, setdataClientSelected, addressNowLocation, setAddressNowLocation, parthner_order, setShoppingCart, calculateInvoiceTotals, enabledOnlineOrder, parthners, selectRestaurant, setResetData, shoppingCart, shoppingCartCombos, setShoppingCartCombos, questionConfirmation }) {
  //********************************STATE VARIABLES*****************************************
  const [showDirectParthner, setShowDirectParthner] = useState(false);
  //STATES CLIENTS
  const [clients, setClients] = useState([]);
  //-----------------------------------------
  //STATES ORDERS
  const [ordersClient, setOrdersClient] = useState([])
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [tempSelectedClient, setTempSelectedClient] = useState(null);

  //-----------------------------------------//STATES CLIENT INFO EDIT
  const [nameEdit, setNameEdit] = useState("");
  const [PhoneEdit, setPhoneEdit] = useState("");
  const [nicknameEdit, setNicknameEdit] = useState("");
  const [EmailEdit, setEmailEdit] = useState("");
  const [rucEdit, setRucEdit] = useState("");
  const [dvEdit, setDvEdit] = useState("");
  const [OrdersQuote, setOrdersQuote] = useState([])
  const [showQuoteDetails, setShowQuoteDetails] = useState(false);
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [branchOfficeData, setBranchofficeData] = useState({
    "ruc": "",
    "dv": "",
    "name": "",
    "ruc_type": "",
    "direction": "",
    "dgi_name": "",
  });

  useEffect(() => {
    dataSetClientEdit(dataClientSelected)
  }, [])

  //function to set data edit client
  const dataSetClientEdit = (client) => {
    setNameEdit(client !== null && client.name !== undefined ? client.name : '');
    setPhoneEdit(client !== null && client.phone !== undefined ? client.phone : '');
    setNicknameEdit(client !== null && client.nickname !== undefined ? client.nickname : '');
    setEmailEdit(client !== null && client.email !== undefined ? client.email : '');
    setRucEdit(client !== null && client.ruc !== undefined ? client.ruc : '');
    setDvEdit(client !== null && client.dv !== undefined ? client.dv : '');
  }
  //-----------------------------------------
  //STATES ADDRESS
  const [address, setAddress] = useState([]);
  const [coordinates, setCoordinates] = useState({ lat: 0, lng: 0 });
  const [selectedAddress, setSelectedAddress] = useState(null);

  //-----------------------------------------
  //MODALS AND TABS FLOW
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState('info');
  const [showAddAddress, setShowAddAddress] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isChangingClient, setIsChangingClient] = useState(false);
  //****************************************************************************************
  //****************************************************************************************
  //**************************************INFO GENERAL**************************************
  //CREDENTIALS AND MACHINE INFO
  const token = localStorage.getItem("x-access-machine-token");
  const [business_code, setbusiness_code] = useState(() => {
    if (localStorage.getItem("business") != "" && localStorage.getItem("business") != undefined) {
      return JSON.parse(localStorage.getItem("business")).code
    }
  });

  const [branchoffice_code, setbranchoffice_code] = useState(() => {
    if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined) {
      return JSON.parse(localStorage.getItem("branchoffice")).code
    }
  });

  const [machine, setmachine] = useState(() => {
    if (localStorage.getItem("machine") != "" && localStorage.getItem("machine") != undefined) {
      return JSON.parse(localStorage.getItem("machine"))
    }
  });

  let iconGeneral = ""
  if (localStorage.getItem('businessLogo') != null || localStorage.getItem('businessLogo') != undefined || localStorage.getItem('businessLogo') != "") {
    iconGeneral = localStorage.getItem('businessLogo')
  }
  //****************************************************************************************
  //*************************FILTER DATA CLIENTS "SEARCHS"**********************************

  //Filter clients
  const [searchTerm, setSearchTerm] = useState('');
  const [searchedClients, setSearchedClients] = useState("")
  const [orderSort, setOrderSort] = useState('asc')

  //Filter the products by the term searched 
  const filteredProducts = useMemo(() => {
    if (searchTerm === '') {
      return clients
    }
    const term = searchTerm.toLowerCase();
    return searchedClients.filter(data => {
      console.log("cliente data:", data);
      const nameMatch = data.name.toLowerCase().includes(term);
      const phoneMatch = (data.phone || '').toLowerCase().includes(term);
      const emailMatch = (data.email || '').toLowerCase().includes(term);
      return nameMatch || phoneMatch || emailMatch;

    })
  }, [searchTerm, clients]);

  //****************************************************************************************
  //************************SELECT CLIENT AND FILTER DATA CLIENTS***************************
  //get client by business 
  const getClientsByBusiness = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        let token = localStorage.getItem('x-access-machine-token');
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let business_id = JSON.parse(localStorage.getItem('business')).id
        if (parthner_order == true) {
          business_id = branchoffice.parthner_business
        }
        const response = await ClientsFetchAPI.getClientsByBusiness(business_id, token);
        resolve(response.data.data);
        let clientSort = sortJSON(response.data.data, "name")
        setClients(clientSort)
        setSearchedClients(clientSort)

        console.log(clientSort);
        setOrderSort('asc')
        setIsChangingClient(true)
      } catch (err) {
        setClients([])
        setSearchedClients([])
        setOrderSort('asc')
        setIsChangingClient(true)
        AlertSmall('Error al obtener los clientes', 'error');
        console.log(err);
        reject(err);
      }
    });
  }

  //function to handle filter
  const handleFilter = () => {
    if (orderSort === 'asc') {
      setOrderSort('desc')
    } else {
      setOrderSort('asc')
    }
    if (searchTerm === '') {
      sortJSON(clients, 'name')
    } else {
      sortJSON(filteredProducts, 'name')
    }
  }

  //function to sort json
  function sortJSON(data, key) {
    return data.sort(function (a, b) {
      var x = a[key],
        y = b[key];

      if (orderSort === 'asc') {
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      }

      if (orderSort === 'desc') {
        return ((x > y) ? -1 : ((x < y) ? 1 : 0));
      }
    });
  }

  //FUNCTION TO CHANGE CLIENT
  const handleChangeClient = (client) => {
    if (client) {

      localStorage.setItem('client_data', JSON.stringify(client));
      setdataClientSelected(client);
      setIsChangingClient(false);
      setTempSelectedClient(null);
      setActiveTab('info');
      getTransactionByClient(client.id)
      getOrderQuote(client.id)
      dataSetClientEdit(client)
    }
  };

  //****************************************************************************************
  //********************************GET ORDERS BY CLIENT************************************
  const [minDate, setMinDate] = useState(moment().subtract(3, 'months').tz('America/Bogota').format('YYYY-MM-DD') + 'T00:00:00.000+00:00');
  const [maxDate, setMaxDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000+00:00');

  //function to handle range change
  const [selectedRange, setSelectedRange] = useState('threeMonths');

  // Handle range change and call the corresponding function
  const handleRangeChange = (range) => {
    setSelectedRange(range);
    if (range === 'threeMonths') setRangeThreeMonths();
    if (range === 'sixMonths') setRangeSixMonths();
    if (range === 'oneYear') setRangeOneYear();
  };

  // Set range to last 3 months
  const setRangeThreeMonths = () => {
    const startDate = moment().subtract(3, 'months').tz('America/Bogota').format('YYYY-MM-DD') + 'T00:00:00.000+00:00';
    const endDate = moment().tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000+00:00';
    setMinDate(startDate);
    setMaxDate(endDate);
    getTransactionByClient(dataClientSelected.id, startDate, endDate);
    getOrderQuote(dataClientSelected.id, startDate, endDate);
  };

  // Set range to last 6 months
  const setRangeSixMonths = () => {
    const startDate = moment().subtract(6, 'months').tz('America/Bogota').format('YYYY-MM-DD') + 'T00:00:00.000+00:00';
    const endDate = moment().tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000+00:00';
    setMinDate(startDate);
    setMaxDate(endDate);
    getTransactionByClient(dataClientSelected.id, startDate, endDate);
    getOrderQuote(dataClientSelected.id, startDate, endDate)
  };

  // Set range to last 1 year
  const setRangeOneYear = () => {
    const startDate = moment().subtract(12, 'months').tz('America/Bogota').format('YYYY-MM-DD') + 'T00:00:00.000+00:00';
    const endDate = moment().tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000+00:00';
    setMinDate(startDate);
    setMaxDate(endDate);
    getTransactionByClient(dataClientSelected.id, startDate, endDate);
    getOrderQuote(dataClientSelected.id, startDate, endDate)
  };


  // Fetch order quote details
  const getOrderQuote = async (client_id, dateintial, dateend) => {
    let min = dateintial || minDate;
    let max = dateend || maxDate;
    try {
      const responsePending = await OrdersFetchAPI.getOrdersTempPendingByClienId(business_code, branchoffice_code, min, max, 0, 0, machine.id, 0, token, client_id, true)
      setOrdersQuote(responsePending.data.temp_orders)

    } catch (err) {
      setOrdersQuote([])
    }
  }

  //get orders by client
  const getTransactionByClient = async (client_id, dateintial, dateend) => {
    let min = dateintial || minDate;
    let max = dateend || maxDate;
    try {
      const response = await OrdersFetchAPI.getTransactionsByBranchOfficePaymentMethodbyTable(business_code, branchoffice_code, min, max, 0, 0, 0, 0, token, client_id);
      console.log("historico de transacciones del cliente", response.data.orders);
      setOrdersClient(response.data.orders)
    } catch (error) {
      console.log(error);
    }
  }
  //*************************************************************************
  //********************************GET ADDRESS BY CLIENT******************** 

  //get address by client
  const getAddressClientNow = async () => {
    try {
      const response = await ClientsFetchAPI.getAddressClient(dataClientSelected.id, token);
      setAddress(response.data.data)


      console.log(addressNowLocation);

      if (addressNowLocation == null) {
        let defaultAddress = response.data.data.find(addr => addr.is_default === 1);

        if (defaultAddress) {
          setData(defaultAddress)
        } else {
          setData(response.data.data[0]);
        }

        function setData(data) {
          setSelectedAddress(data);
          setAddressNowLocation(data);
          localStorage.setItem("addressNowLocation", JSON.stringify(data));
        }

      }

      console.log(coordinates);

    } catch (err) {
      setAddress([])
      console.log("Error al obtener las direcciones del cliente: ", err);
    }
  }

  //get address by id
  const getAddressByIdNow = async (direction_id) => {
    try {
      const response = await ClientsFetchAPI.getAddressById(direction_id, token);
      setAddressNowLocation(response.data.direction)
      setSelectedAddress(response.data.direction);
      setActiveTab('info')
      localStorage.setItem("addressNowLocation", JSON.stringify(response.data.direction));
    } catch (err) {
      console.log("Error al obtener la direccion por id: ", err);
    }
  }

  //update address client
  const updateClientAddress = async (address_id, data) => {
    let dataSource = data
    dataSource.is_default = data.is_default === 1 ? 0 : 1
    try {
      const response = await ClientsFetchAPI.updateAddressClient(address_id, dataSource, token);
      getAddressClientNow()
    } catch (err) {
      console.log(err);
    }
  }



  //function to delete address client
  const deleteClientAddress = async (address_id) => {
    try {
      const response = await ClientsFetchAPI.deleteAddressClient(address_id, token);
      ErrorAlert("Exito", "Direccion eliminada correctamente", "success")
      getAddressClientNow()
    } catch (error) {
      ErrorAlert("", error.message, "error")
    }
  }

  //function to save address selected
  const handleSaveAddressSelection = (address) => {
    AlertSmall(`Dirección "${address.name}" seleccionada como dirección de entrega`, 'info');
    localStorage.setItem("addressNowLocation", JSON.stringify(address));
    setAddressNowLocation(address);
    setSelectedAddress(address);
    setActiveTab('info')
  };

  //****************************************************************************************
  //********************************EDIT DATA CLIENT****************************************
  const getClientType = async (dTipoRec) => {
    let token = localStorage.getItem('x-access-machine-token');
    try {
      const responseTypeClient = await ClientsFetchAPI.getClientType(token)
      console.log(responseTypeClient);
      let dataTypes = responseTypeClient.data.data;

      let dataNow = dataTypes.find(type => type.name.toLowerCase() == dTipoRec.toLowerCase())
      if (dataNow != undefined) { return dataNow.id } else { return 2 }
    } catch (err) {
      console.log(err);
      return 2;
    }
  }

  const authenticationDgi = async () => {
    if (rucEdit == "") {
      return 0
    } else {
      let token = localStorage.getItem('x-access-machine-token');
      let data = { ruc: rucEdit }
      try {
        const response = await AuthDgiFetchAPI.authenticationRuc(token, data)
        let dataDgi = response.data
        let dTipoRec = dataDgi?.dgi_response?.dTipoRec ? dataDgi.dgi_response.dTipoRec : "Consumidor final"
        let clientType = await getClientType(dTipoRec)


        if (dataDgi.dgi_response.gResProc) {
          if (dataDgi.dgi_response.gResProc.dCodRes == "0680") {
            let dvDgi = dataDgi.dgi_response.dDV
            if (dvDgi.length < 2) { dvDgi = "0" + dvDgi }
            return { clientType: clientType, billing_name: dataDgi.dgi_response.dNomb, dv: dvDgi, typeRuc: dataDgi.dgi_response.dTipoRuc };
          } else {
            return 0
          }
        }
      } catch (err) {
        console.log(err);
        return 0

      }
    }
  }

  const getTemporalOrderById = async (order) => {
    try {
      let token = localStorage.getItem('x-access-machine-token');
      const response = await OrdersFetchAPI.getTempOrderById(order._id, token);
      let dataOrder = response.data.pre_order

      console.log("DataOrder quote", dataOrder);
      const dataclient = await getClientById(dataOrder.client_id)
      questionConfirmation(dataOrder, dataclient)
      setShowModal(false);
    } catch (err) {
      console.log(err);
    }
  }

  //get client by id 
  const getClientById = async (client_id) => {
    try {
      let machine_token = localStorage.getItem('x-access-machine-token');
      const response = await ClientsFetchAPI.getClientsById(client_id, machine_token);
      return response.data.data;

    } catch (err) {
      return null
    }
  }

  const editUser = async () => {
    LoadingAlert('Editando usuario')
    let token = localStorage.getItem('x-access-machine-token')
    let business = JSON.parse(localStorage.getItem('business'))

    let data = {};

    const authDgi1 = await authenticationDgi();

    if (nameEdit !== dataClientSelected.name) data.name = nameEdit;
    if (PhoneEdit !== dataClientSelected.phone) data.phone = PhoneEdit;
    if (EmailEdit !== dataClientSelected.email) data.email = EmailEdit;
    if (nicknameEdit !== dataClientSelected.nickname) data.nickname = nicknameEdit;
    if (rucEdit !== dataClientSelected.ruc) data.ruc = rucEdit;
    if (dvEdit !== dataClientSelected.dv) data.dv = dvEdit;

    // Estos campos siempre se envían
    if (authDgi1 !== 0) {
      data.billing_name = authDgi1.billing_name;
      data.client_type_id = authDgi1.clientType;
      data.dv = authDgi1.dv;
      data.client_ruc_type = authDgi1.typeRuc;
    }
    data.business_code = business.code;

    try {
      const response = await ClientsFetchAPI.updateClient(data, dataClientSelected.id, token)
      AlertSmall('Usuario actualizado con exito', 'success')
      const responseClients = await getClientsByBusiness()
      let clientUpdated = responseClients.find(client => client.id === dataClientSelected.id);
      setdataClientSelected(clientUpdated);
      localStorage.setItem('client_data', JSON.stringify(clientUpdated));
      setIsEditing(false)
      setIsChangingClient(false);
    } catch (err) {
      console.log(err)
      ErrorAlert('', err.response.data.error ? err.response.data.error : "Error al crear usuario", 'error')
    }

  }
  //****************************************************************************************
  //********************************MODAL FLOW**********************************************
  const handleOpenModal = () => {
    setShowModal(true);
    setActiveTab('info');
    setIsEditing(false);
    setShowAddAddress(false);
    setSelectedOrder(null);
    setIsChangingClient(false);
    setTempSelectedClient(null);

    if (!dataClientSelected) {

      getClientsByBusiness();
      setIsChangingClient(true);
    } else {
      getAddressClientNow()
      getTransactionByClient(dataClientSelected.id)
    }
  };


  const handleRemoved = () => {
    setShowModal(false);
    setActiveTab('info');
    setIsEditing(false);
    setShowAddAddress(false);
    setSelectedOrder(null);
    setIsChangingClient(false);
    setTempSelectedClient(null);
    localStorage.removeItem('client_data');
    localStorage.removeItem('addressNowLocation');
    setdataClientSelected(null);
    setAddressNowLocation(null);

  };

  //****************************************************************************************
  //****************************************************************************************
  //*******************************SEND ORDER TO THE SHOPPING CART**************************

  const handleSendToCart = (orderDirect) => {
    let Order = orderDirect || selectedOrder;
    if (Order) {
      //alert(`Pedido #${selectedOrder.id} agregado al carrito con ${selectedOrder.productos.length} productos`);
      let groupsOrderNow = JSON.parse(JSON.stringify(Order.groups));
      if (Order.groups.length > 0) {
        findProductinMenu(groupsOrderNow)
      }
    }
  };

  //function to find products in menu to set data of old order
  const findProductinMenu = (groups) => {
    let foundGroupsWithCartIndex = []
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    let generalData = JSON.parse(localStorage.getItem('generalData'))
    let generalDataBranchGroups = generalData.find((dataNow) => {
      if (dataNow.branchoffice_id == branchoffice.id) {
        return dataNow
      }
    })
    let groupEnabled = generalDataBranchGroups?.data?.groups.filter(group => group.status === 1);
    groupEnabled.forEach(group => {
      let dataGroupNow = groups.find(item => group.group_id === item.group_id)
      if (dataGroupNow !== undefined) {
        dataGroupNow.segmentsOption = group.segments
        dataGroupNow.price = group.price
        foundGroupsWithCartIndex.push(addProductdataSet(dataGroupNow, group.segments, dataGroupNow.segments))
      }
    });

    setShoppingCart(foundGroupsWithCartIndex)
    calculateInvoiceTotals(foundGroupsWithCartIndex, [])
    AlertSmall(`Pedido agregado al carrito con ${foundGroupsWithCartIndex.length} productos`, 'success');
    handleCloseModal()

  }

  //Function to add format products to the shopping cart
  const addProductdataSet = (selectProduct, segmentsOption, segmentsSelect) => {
    console.log("selectProduct to add to cart", selectProduct);
    console.log("segmentsOption", segmentsOption);
    console.log("segmentsSelect", segmentsSelect);
    //------------------------------------------------------------
    //For default we set that the amount of the selected product depending the number 
    selectProduct.isNewAdd = true;
    selectProduct.amount = selectProduct.amount;
    selectProduct.cantidadItem = selectProduct.cantidadItem;
    selectProduct.delivery_type = "comer aqui";
    selectProduct.note = selectProduct.notes;
    selectProduct.unit_discount = 0;
    selectProduct.product_discount = 0;
    selectProduct.descuento = selectProduct.product_discount;
    selectProduct.discount = selectProduct.product_discount;
    selectProduct.kitchen_action = "send_to_kitchen"; // <-- NEW

    //For default we initialice the segments empty of the selected product
    let segments = [];
    let detalleSegmentos = [];
    selectProduct.segments_string = "" + selectProduct.group_id
    //We set the segment items selected on the product selected

    let temporal_segment_string = ""
    segmentsOption.forEach((segment) => {

      let items = segment.items

      let findSegment = segmentsSelect.find(segmentNow => segmentNow?.segment_id == segment?.segment_id)
      if (findSegment !== undefined) {
        items.forEach((item) => {
          if (findSegment?.item?.item_id == item?.item_id) {
            temporal_segment_string = selectProduct.segments_string + "" + segment.segment_id + "" + item.item_id
            selectProduct.segments_string = selectProduct.segments_string + "" + segment.segment_id + "" + item.item_id
            segments.push({ ...item, segment_name: segment.name, cantidadItem: 1, item: { name: item.name, description: item.description, img: item.img, price: item.price, item_id: item.item_id, amount: 1, taxtValue: item.taxtValue, tax: item.tax, external_reference: item.external_reference } })
            detalleSegmentos.push({ ...item, segment_name: segment.name, cantidadItem: 1, item: { name: item.name, description: item.description, img: item.img, price: item.price, item_id: item.item_id, amount: 1, taxtValue: item.taxtValue, tax: item.tax, external_reference: item.external_reference } })
            selectProduct.price = selectProduct.price + item.price
          }
        })
      }
    });

    console.log("segments", segments);
    selectProduct.segments = segments;
    selectProduct.DetalleSegmentos = detalleSegmentos;

    return (selectProduct)
  }

  //****************************************************************************************


  const handleCloseModal = () => {
    setShowModal(false);
    setIsEditing(false);
    setShowAddAddress(false);
    setIsChangingClient(false);
    setTempSelectedClient(null);
  };

  const actionDistanceAddress = (address) => {
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))

    const centerLat = branchoffice.lat; // Example: Panama City
    const centerLng = branchoffice.lng;
    const deliveryRadiusKm = 1; // 10 km radius

    // When user selects a location:
    const isInsideDeliveryArea = getDistanceFromLatLonInKm(
      centerLat,
      centerLng,
      address.lat,
      address.lng
    ) <= deliveryRadiusKm;

    if (!isInsideDeliveryArea) {

      if (parthners.length > 0) {
        console.log("Sucursal mas cercana: ", parthners);
        handleSaveAddressSelection(address)
      } else {
        ErrorAlert("Fuera del área de entrega", `La dirección seleccionada está fuera del área de entrega de ${deliveryRadiusKm} km.`, "warning");
      }

    } else {
      handleSaveAddressSelection(address)
    }
  }


  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the earth in km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;
  }



  useEffect(() => {
    (async () => {


      try {
        let business = ''
        let token = ''
        let branchoffice = ''
        if (localStorage.getItem("branchoffice") !== "" || localStorage.getItem("branchoffice") !== null || localStorage.getItem("branchoffice") !== undefined) {

          business = JSON.parse(localStorage.getItem("business"))
          branchoffice = JSON.parse(localStorage.getItem("branchoffice"))

        }

        //We get the branchoffice info 
        const response_branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(business.code, branchoffice.code);
        //We set the business data 
        setBranchofficeData(response_branch.data.branchoffice);

      } catch (err) {
        setBranchofficeData({
          "ruc": "",
          "dv": "",
          "name": "",
          "ruc_type": "",
          "direction": "",
          "dgi_name": "",
        })
      }
    })();
  }, []);



  return (
    <div className="">
      {parthners.length > 0 && <ModalParthners parthners={parthners} selectRestaurant={selectRestaurant} setResetData={setResetData} calculateInvoiceTotals={calculateInvoiceTotals} shoppingCart={shoppingCart} shoppingCartCombos={shoppingCartCombos} setShoppingCart={setShoppingCart} setShoppingCartCombos={setShoppingCartCombos} showDirectParthner={showDirectParthner} buttonEnabled={false} />
      }
      <div className="sp-clientbar" onClick={() => handleOpenModal()}>
        <div className="sp-clientbar__id">
          <div className={`sp-clientbar__av ${dataClientSelected !== null ? 'is-assigned' : ''}`}>
            <i className="uil uil-user-circle"></i>
          </div>
          <div className="sp-clientbar__info">
            <div className="sp-clientbar__name">
              {dataClientSelected?.name !== undefined ? dataClientSelected.name : <>Selecciona un cliente</>}
            </div>
            <div className="sp-clientbar__sub">Cliente</div>
          </div>
        </div>

        <div className="sp-clientbar__acts" onClick={(e) => e.stopPropagation()}>
          <button className="sp-clientbar__btn" onClick={() => handleOpenModal()}>
            {dataClientSelected !== null ? <>Ver detalle</> : <>Buscar o crear</>}
          </button>

          {dataClientSelected !== null && (
            <button className="sp-clientbar__btn sp-clientbar__btn--danger" onClick={() => handleRemoved()}>
              Remover
            </button>
          )}
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="sp-cmodal-overlay" onClick={handleCloseModal}>
          <div
            className={`sp-cmodal ${isChangingClient ? 'is-compact' : ''}`}
            role="dialog" aria-modal="true"
            onClick={(e) => e.stopPropagation()}
          >

            {/* ===== HEADER ===== */}
            <div className="sp-cmodal__head">
              <div className="sp-cmodal__id">
                <div className={`sp-cmodal__av ${dataClientSelected !== null ? 'is-assigned' : ''}`}>
                  <i className="uil uil-user-circle"></i>
                </div>
                <div className="sp-cmodal__idinfo">
                  <div className="sp-cmodal__name">
                    {dataClientSelected?.name !== undefined ? dataClientSelected.name : <>Selecciona un cliente</>}
                  </div>
                  <div className="sp-cmodal__sub">Cliente</div>
                </div>
              </div>

              {!isEditing && !isChangingClient && (
                <div className="sp-cmodal__acts">
                  <button className="sp-cbtn" onClick={() => getClientsByBusiness()}>Cambiar cliente</button>
                  <button className="sp-cbtn sp-cbtn--primary" onClick={() => setIsEditing(true)}>Editar cliente</button>
                  {dataClientSelected !== null && (
                    <button className="sp-cbtn sp-cbtn--danger" onClick={() => handleRemoved()}>Remover</button>
                  )}
                </div>
              )}

              <button className="sp-cmodal__x" onClick={handleCloseModal} aria-label="Cerrar" type="button">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
              </button>
            </div>

            {/* ===== BODY ===== */}
            <div className="sp-cmodal__body">
              {/* Body */}
              <div className="modal-body px-4" style={{ overflowY: 'auto', flex: 1 }}>

                {isChangingClient ? (
                  /* Selección de Cliente */

                  <div className="sp-cpick">
                    {/* Buscar + ordenar */}
                    <div className="sp-cpick__top">
                      <div className="sp-cpick__search">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
                        <input
                          spellCheck="false"
                          type="text"
                          placeholder="Buscar cliente..."
                          onChange={e => setSearchTerm(e.target.value)}
                        />
                      </div>
                      <button type="button" className="sp-cpick__sort" onClick={() => handleFilter()}>
                        {orderSort === 'asc'
                          ? <><i className="uil uil-sort-amount-down"></i> A-Z</>
                          : <><i className="uil uil-sort-amount-up"></i> Z-A</>}
                      </button>
                    </div>

                    {/* Crear cliente (ancho) */}
                    <div className="sp-cpick__create">
                      <ModalCreateNewClient getClients={getClientsByBusiness}></ModalCreateNewClient>
                    </div>

                    {/* Lista en filas */}
                    <div className="sp-cpick__list">
                      {filteredProducts.map((client) => {
                        const isSelected = tempSelectedClient?.id === client.id;
                        return (
                          <div
                            key={client.id}
                            className={`sp-crow ${isSelected ? 'is-selected' : ''}`}
                            onClick={() => { setTempSelectedClient(client); handleChangeClient(client); }}
                            role="button"
                            tabIndex={0}
                          >
                            <span className="sp-crow__radio" aria-hidden="true"></span>

                            <span className="sp-crow__info">
                              <span className="sp-crow__name">{client.name}</span>
                              <span className="sp-crow__email">{client.email}</span>
                            </span>

                            {(client.ruc || client.billing_name) && <span className="sp-crow__tag">DGI</span>}

                            <svg className="sp-crow__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor"><polyline points="9 18 15 12 9 6" /></svg>
                          </div>
                        );
                      })}

                      {filteredProducts.length === 0 && (
                        <div className="sp-cpick__empty"><i className="uil uil-users-alt"></i> No se encontraron clientes</div>
                      )}
                    </div>
                  </div>
                ) : isEditing ? (
                  /* Formulario de Edición */
                  <div className="sp-cedit">
                    <div className="sp-cedit__title">Editar información del cliente</div>

                    <div className="sp-cform">
                      <div className="sp-cfield sp-cfield--full">
                        <label className="sp-clabel">Nombre completo</label>
                        <input
                          type="text"
                          className="sp-cinput"
                          value={nameEdit}
                          onChange={e => setNameEdit(e.target.value)}
                          placeholder={dataClientSelected?.name}
                          name="name"
                        />
                      </div>

                      <div className="sp-cfield">
                        <label className="sp-clabel">Teléfono</label>
                        <PhoneInput
                          country={'pa'}
                          value={PhoneEdit}
                          onChange={phone => (setPhoneEdit(phone))}
                          inputProps={{ name: 'phone', required: true, autoFocus: true }}
                          countryCodeEditable={false}
                          masks={{ pa: '.... ....' }}
                          enableSearch
                        />
                      </div>

                      <div className="sp-cfield">
                        <label className="sp-clabel">Email</label>
                        <input
                          type="email"
                          className="sp-cinput"
                          value={EmailEdit}
                          onChange={e => setEmailEdit(e.target.value)}
                          placeholder={dataClientSelected?.email}
                          name="email"
                        />
                      </div>

                      <div className="sp-cfield">
                        <label className="sp-clabel">Ruc</label>
                        <input
                          type="text"
                          className="sp-cinput"
                          value={rucEdit}
                          onChange={e => setRucEdit(e.target.value)}
                          placeholder={dataClientSelected?.ruc}
                          name="email"
                        />
                      </div>

                      <div className="sp-cfield">
                        <label className="sp-clabel">Dv</label>
                        <input
                          type="text"
                          className="sp-cinput"
                          value={dvEdit}
                          onChange={e => setDvEdit(e.target.value)}
                          placeholder={dataClientSelected?.dv}
                          name="email"
                        />
                      </div>
                    </div>

                    <div className="sp-cedit__acts">
                      <button className="sp-cbtn sp-cbtn--primary" onClick={() => editUser()}>Guardar cambios</button>
                      <button className="sp-cbtn" onClick={() => setIsEditing(false)}>Cancelar</button>
                    </div>
                  </div>
                ) : (
                  /* Tabs */
                  <>
                    <div className="sp-ctabs">
                      <button
                        type="button"
                        className={`sp-ctab ${activeTab === 'info' ? 'is-active' : ''}`}
                        onClick={() => setActiveTab('info')}
                      >
                        <i className="uil uil-info-circle"></i> Información
                      </button>

                      <button
                        type="button"
                        className={`sp-ctab ${activeTab === 'pedidos' ? 'is-active' : ''}`}
                        onClick={() => (setActiveTab('pedidos'))}
                      >
                        <i className="uil uil-clipboard-notes"></i> Pedidos
                      </button>

                      <button
                        type="button"
                        className={`sp-ctab ${activeTab === 'quote' ? 'is-active' : ''}`}
                        onClick={() => (setActiveTab('quote'))}
                      >
                        <i className="uil uil-clipboard-notes"></i> Cotizaciones
                      </button>

                      {enabledOnlineOrder == true && (
                        <button
                          type="button"
                          className={`sp-ctab ${activeTab === 'direcciones' ? 'is-active' : ''}`}
                          onClick={() => (setActiveTab('direcciones'), getAddressClientNow())}
                        >
                          <i className="uil uil-location-point"></i> Direcciones
                        </button>
                      )}
                    </div>




                    {/* Tab: Información */}

                    {activeTab === 'info' && (
                      <div className="sp-ci">
                        <div className="sp-ci__title">Información del cliente</div>

                        {/* Datos básicos */}
                        <div className="sp-ci__grid">
                          <div className="sp-ci__card">
                            <div className="sp-ci__label">Teléfono</div>
                            <span className="sp-ci__value">{dataClientSelected?.phone}</span>
                          </div>

                          <div className="sp-ci__card">
                            <div className="sp-ci__label">Email</div>
                            <span className="sp-ci__value sp-ci__value--email">{dataClientSelected?.email}</span>
                          </div>

                          {dataClientSelected?.billing_name && (
                            <div className="sp-ci__card">
                              <div className="sp-ci__label">Nombre fiscal</div>
                              <span className="sp-ci__value">{dataClientSelected.billing_name}</span>
                            </div>
                          )}

                          {dataClientSelected?.ruc && (
                            <div className="sp-ci__card">
                              <div className="sp-ci__label">RUC</div>
                              <span className="sp-ci__value">{dataClientSelected.ruc}</span>
                            </div>
                          )}

                          {dataClientSelected?.dv && (
                            <div className="sp-ci__card">
                              <div className="sp-ci__label">DV</div>
                              <span className="sp-ci__value">{dataClientSelected.dv}</span>
                            </div>
                          )}

                          <div className="sp-ci__card sp-ci__card--points">
                            <div className="sp-ci__label">Puntos</div>
                            <span className="sp-ci__value">{dataClientSelected?.points}</span>
                          </div>
                        </div>

                        {/* Dirección de entrega + Última transacción */}
                        <div className="sp-ci__cols">

                          {/* Columna izquierda: dirección */}
                          <div className="sp-ci__col">
                            {enabledOnlineOrder == true && <>{addressNowLocation !== null ? <>
                              <div className="sp-ci-addr">
                                <div className="sp-ci-addr__head">
                                  <i className="uil uil-map-marker"></i>
                                  <h3 className="sp-ci-addr__title">Dirección de Entrega</h3>
                                </div>

                                <div className="sp-ci-addr__body">
                                  <div className="sp-ci-addr__map">
                                    {addressNowLocation !== null ? (
                                      <ModalViewLocation logo={iconGeneral} address={{ lat: addressNowLocation.lat, lng: addressNowLocation.lng }} />
                                    ) : (
                                      <ModalViewLocation logo={iconGeneral} Address={{ lat: 0, lng: 0 }} />
                                    )}
                                  </div>

                                  <div className="sp-ci-addr__info">
                                    <div className="sp-ci-addr__item">
                                      <i className="uil uil-map-pin-alt"></i>
                                      <span translate="no"><strong>Dirección:</strong> {addressNowLocation.name}</span>
                                    </div>
                                    <div className="sp-ci-addr__item">
                                      <i className="uil uil-estate"></i>
                                      <span translate="no"><strong>Apto/Casa:</strong> {addressNowLocation.house_num}</span>
                                    </div>
                                    <div className="sp-ci-addr__item">
                                      <i className="uil uil-phone"></i>
                                      <span translate="no"><strong>Teléfono:</strong> {addressNowLocation.phone}</span>
                                    </div>
                                    {addressNowLocation?.is_default === 1 &&
                                      <div className="sp-ci-addr__item">
                                        <i className="uil uil-star"></i>
                                        <div className="sp-ci-addr__badge">Direccion predeterminada</div>
                                      </div>
                                    }
                                  </div>

                                  <div className="sp-ci-addr__ref">
                                    <div className="sp-ci-addr__ref-label"><i className="uil uil-file-alt"></i> Referencia</div>
                                    <p className="sp-ci-addr__ref-text" translate="no">{addressNowLocation.additional_info}</p>
                                  </div>
                                </div>

                                <div className="sp-ci-addr__foot">
                                  <button
                                    className="sp-cbtn sp-cbtn--primary"
                                    onClick={() => { setActiveTab('direcciones'); getAddressClientNow(); }}
                                  >
                                    <i className="uil uil-pen"></i> Cambiar dirección
                                  </button>
                                </div>
                              </div>
                            </> : <>
                              <div className="sp-ci-noaddr" onClick={() => (setActiveTab('direcciones'), getAddressClientNow())} role="button" tabIndex={0}>
                                <i className="uil uil-location-point"></i>
                                <p>No tienes dirección seleccionada<br />Seleccionar una aquí</p>
                              </div>
                            </>}</>}
                          </div>

                          {/* Columna derecha: última transacción */}
                          {ordersClient.length > 0 && <>
                            <div className="sp-ci__col">
                              <div className="sp-ci-tx">
                                <div className="sp-ci-tx__head">
                                  <i className="uil uil-history"></i>
                                  <h3 className="sp-ci-tx__title">Última transacción</h3>
                                </div>

                                <div key={ordersClient[0]._id} className="sp-ci-tx__card">
                                  <div className="sp-ci-tx__badgewrap">
                                    <span className={`sp-ci-tx__badge ${ordersClient[0].devolution_order_reference ? 'is-credit' : 'is-invoice'}`}>
                                      <i className="uil uil-invoice"></i>
                                      {ordersClient[0].devolution_order_reference ? 'Nota a crédito' : 'Factura'}
                                    </span>
                                  </div>

                                  <div className="sp-ci-tx__rowhead">
                                    <h6 className="sp-ci-tx__num"><i className="uil uil-shopping-cart"></i> Pedido #{ordersClient[0].transaction_code}</h6>
                                    <div className="sp-ci-tx__date">
                                      <i className="uil uil-calendar"></i>
                                      <small>{moment(ordersClient[0].createdAt).tz('America/Bogota').format('DD/MM/YYYY HH:mm')}</small>
                                    </div>
                                  </div>

                                  <div className="sp-ci-tx__products">
                                    <div className="sp-ci-tx__products-h"><i className="uil uil-box"></i> Productos</div>
                                    <div className="sp-ci-tx__list">
                                      {ordersClient[0].groups.map((group, idx) => (
                                        <div key={idx} className="sp-ci-tx__item">
                                          <div className="sp-ci-tx__iteminfo">
                                            <span className="sp-ci-tx__itemname">{group.name}</span>
                                            <span className="sp-ci-tx__itemqty">×{group.amount}</span>
                                          </div>
                                          <span className="sp-ci-tx__itemprice">${group.price.toFixed(2)}</span>
                                        </div>
                                      ))}
                                    </div>
                                  </div>

                                  <div className="sp-ci-tx__totalsec">
                                    <div className="sp-ci-tx__totalrow">
                                      <span className="sp-ci-tx__totallabel">Total:</span>
                                      <span className="sp-ci-tx__totalamount">${ordersClient[0].total.toFixed(2)}</span>
                                    </div>
                                    <div className="sp-ci-tx__send">
                                      <button className="sp-cbtn sp-cbtn--success" onClick={() => handleSendToCart(ordersClient[0])}>
                                        <i className="uil uil-shopping-cart"></i> Enviar al carrito
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>}
                        </div>
                      </div>
                    )}


                    {/* Tab: Pedidos */}
                    {activeTab === 'pedidos' && (
                      <div className="sp-po">
                        {/* Cabecera: título + rangos + enviar */}
                        <div className="sp-po__head">
                          <h6 className="sp-po__title">Historial de pedidos</h6>

                          <div className="sp-po__ranges" role="group" aria-label="Rango de fechas">
                            <input className="sp-po__radio" type="radio" name="range" id="rangeThreeMonths"
                              checked={selectedRange === 'threeMonths'} onChange={() => handleRangeChange('threeMonths')} />
                            <label className="sp-po__pill" htmlFor="rangeThreeMonths">3 Meses</label>

                            <input className="sp-po__radio" type="radio" name="range" id="rangeSixMonths"
                              checked={selectedRange === 'sixMonths'} onChange={() => handleRangeChange('sixMonths')} />
                            <label className="sp-po__pill" htmlFor="rangeSixMonths">6 Meses</label>

                            <input className="sp-po__radio" type="radio" name="range" id="rangeOneYear"
                              checked={selectedRange === 'oneYear'} onChange={() => handleRangeChange('oneYear')} />
                            <label className="sp-po__pill" htmlFor="rangeOneYear">1 Año</label>
                          </div>

                          {selectedOrder && (
                            <button className="sp-cbtn sp-cbtn--success" onClick={() => handleSendToCart()}>
                              <i className="uil uil-shopping-cart"></i> Enviar al carrito
                            </button>
                          )}
                        </div>

                        {/* Grid de pedidos */}
                        <div className="sp-po__grid">
                          {ordersClient.map((order) => {
                            const isSelected = selectedOrder?._id === order._id;
                            const isCreditNote = order.devolution_order_reference;

                            return (
                              <div
                                key={order._id}
                                onClick={() => !isCreditNote && setSelectedOrder(order)}
                                className={`sp-ocard ${isSelected ? 'is-selected' : ''} ${isCreditNote ? 'is-credit' : ''}`}
                                role={!isCreditNote ? 'button' : undefined}
                                tabIndex={!isCreditNote ? 0 : undefined}
                              >
                                {!isCreditNote && (
                                  <span className="sp-ocard__tick">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
                                  </span>
                                )}

                                <div className="sp-ocard__badgewrap">
                                  <span className={`sp-ocard__badge ${isCreditNote ? 'is-credit' : 'is-invoice'}`}>
                                    <i className="uil uil-invoice"></i>
                                    {isCreditNote ? 'Nota a crédito' : 'Factura'}
                                  </span>
                                </div>

                                <div className="sp-ocard__head">
                                  <h3 className="sp-ocard__num">Pedido #{order.transaction_code}</h3>
                                  <div className="sp-ocard__date">
                                    <i className="uil uil-calendar"></i>
                                    <span>{moment(order.createdAt).tz('America/Bogota').format('DD/MM/YYYY HH:mm')}</span>
                                  </div>
                                </div>

                                <div className="sp-ocard__products">
                                  <div className="sp-ocard__products-h"><i className="uil uil-box"></i> Productos</div>
                                  <div className="sp-ocard__list">
                                    {order.groups.map((group, idx) => (
                                      <div key={idx} className="sp-ocard__item">
                                        <div className="sp-ocard__iteminfo">
                                          <span className="sp-ocard__itemname">{group.name}</span>
                                          <span className="sp-ocard__itemqty">×{group.amount}</span>
                                        </div>
                                        <span className="sp-ocard__itemprice">${group.price.toFixed(2)}</span>
                                      </div>
                                    ))}
                                  </div>
                                </div>

                                <div className="sp-ocard__totalsec">
                                  <div className="sp-ocard__totalrow">
                                    <span className="sp-ocard__totallabel">Total:</span>
                                    <span className="sp-ocard__totalamount">${order.total.toFixed(2)}</span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}

                          {ordersClient.length === 0 && (
                            <div className="sp-po__empty"><i className="uil uil-clipboard-notes"></i> Sin pedidos en este rango</div>
                          )}
                        </div>
                      </div>
                    )}
                    {activeTab === 'quote' && (
                      <div className="sp-po">
                        {/* Cabecera: título + rangos */}
                        <div className="sp-po__head">
                          <h6 className="sp-po__title">Cotizaciones</h6>

                          <div className="sp-po__ranges" role="group" aria-label="Rango de fechas">
                            <input className="sp-po__radio" type="radio" name="range-quote" id="rangeThreeMonthsQuote"
                              checked={selectedRange === 'threeMonths'} onChange={() => handleRangeChange('threeMonths')} />
                            <label className="sp-po__pill" htmlFor="rangeThreeMonthsQuote">3 Meses</label>

                            <input className="sp-po__radio" type="radio" name="range-quote" id="rangeSixMonthsQuote"
                              checked={selectedRange === 'sixMonths'} onChange={() => handleRangeChange('sixMonths')} />
                            <label className="sp-po__pill" htmlFor="rangeSixMonthsQuote">6 Meses</label>

                            <input className="sp-po__radio" type="radio" name="range-quote" id="rangeOneYearQuote"
                              checked={selectedRange === 'oneYear'} onChange={() => handleRangeChange('oneYear')} />
                            <label className="sp-po__pill" htmlFor="rangeOneYearQuote">1 Año</label>
                          </div>
                        </div>

                        {/* Grid de cotizaciones */}
                        <div className="sp-po__grid">
                          {OrdersQuote.length === 0 && (
                            <div className="sp-po__empty"><i className="uil uil-clipboard-notes"></i> No hay cotizaciones.</div>
                          )}

                          {OrdersQuote.map((quote) => (
                            <div key={quote._id} className="sp-ocard sp-ocard--quote">
                              <div className="sp-ocard__badgewrap">
                                <span className="sp-ocard__badge is-quote"><i className="uil uil-clipboard-notes"></i> Cotización</span>
                              </div>

                              <div className="sp-ocard__head">
                                <h3 className="sp-ocard__num">Cotización #{quote.transaction_code}</h3>
                                <div className="sp-ocard__date">
                                  <i className="uil uil-calendar"></i>
                                  <span>{moment(quote.createdAt).tz('America/Bogota').format('DD/MM/YYYY HH:mm')}</span>
                                </div>
                              </div>

                              <div className="sp-ocard__products">
                                <div className="sp-ocard__products-h"><i className="uil uil-box"></i> Productos</div>
                                <div className="sp-ocard__list">
                                  {quote.groups.map((group, idx) => (
                                    <div key={idx} className="sp-ocard__item">
                                      <div className="sp-ocard__iteminfo">
                                        <span className="sp-ocard__itemname">{group.name}</span>
                                        <span className="sp-ocard__itemqty">×{group.amount}</span>
                                      </div>
                                      <span className="sp-ocard__itemprice">${group.price.toFixed(2)}</span>
                                    </div>
                                  ))}
                                </div>
                              </div>

                              <div className="sp-ocard__totalsec">
                                <div className="sp-ocard__totalrow">
                                  <span className="sp-ocard__totallabel">Total:</span>
                                  <span className="sp-ocard__totalamount">${quote.total.toFixed(2)}</span>
                                </div>
                                <div className="sp-qmeta"><span>Cliente:</span><span translate="no">{quote.client_name}</span></div>
                                <div className="sp-qmeta"><span>RUC:</span><span translate="no">{quote.client_ruc}</span></div>
                                <div className="sp-qmeta"><span>DV:</span><span translate="no">{quote.client_dv}</span></div>
                              </div>

                              <div className="sp-ocard__acts">
                                <button
                                  className="sp-cbtn"
                                  onClick={() => { setSelectedQuote(quote); setShowQuoteDetails(true); }}
                                >
                                  Ver detalle
                                </button>
                                <button
                                  className="sp-cbtn sp-cbtn--success"
                                  onClick={() => { getTemporalOrderById(quote); }}
                                >
                                  <i className="uil uil-shopping-cart"></i> Enviar al carrito
                                </button>
                              </div>
                            </div>
                          ))}

                          {/* Modal para ver detalle de cotización — intacto */}
                          <ModalQuoteDetails
                            show={showQuoteDetails}
                            onClose={() => setShowQuoteDetails(false)}
                            quote={selectedQuote}
                            branchOfficeData={branchOfficeData}
                            logo={iconGeneral}
                            onShare={() => {
                              if (selectedQuote) {
                                const domainBusiness = (localStorage.getItem('business') && JSON.parse(localStorage.getItem('business')).domain) || '';
                                navigator.clipboard.writeText(`https://${domainBusiness}.ecommerce.smartpay.ai/order/quote/${selectedQuote.code}`);
                                Swal.fire('¡Enlace copiado!', 'El enlace de la cotización ha sido copiado al portapapeles.', 'success');
                              }
                            }}
                          />
                        </div>
                      </div>
                    )}

                    {/* Tab: Direcciones */}
                    {activeTab === 'direcciones' && (
                      <div className="sp-ad">
                        {!showAddAddress ? (
                          <>
                            <div className="sp-ad__head">
                              <h6 className="sp-ad__title">Direcciones guardadas</h6>
                              <div className="sp-ad__headacts">
                                {/*selectedAddress && (
              <button className="sp-cbtn sp-cbtn--success" onClick={handleSaveAddressSelection}>
                💾 Guardar selección
              </button>
            )*/}
                                <button className="sp-cbtn sp-cbtn--primary" onClick={() => setShowAddAddress(true)}>
                                  <i className="uil uil-plus"></i> Agregar dirección
                                </button>
                              </div>
                            </div>

                            <div className="sp-ad__grid">
                              {address.map((dir) => {
                                const isSelected = selectedAddress?.id === dir.id;
                                const isPrincipal = dir.principal;

                                return (
                                  <div
                                    key={dir.id}
                                    onClick={() => actionDistanceAddress(dir)}
                                    className={`sp-adcard ${isSelected ? 'is-selected' : ''} ${isPrincipal ? 'is-principal' : ''}`}
                                    role="button"
                                    tabIndex={0}
                                  >
                                    <span className="sp-adcard__tick">
                                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
                                    </span>

                                    {isSelected && <div className="sp-adcard__pill">Principal</div>}

                                    <div className="sp-adcard__content">
                                      <div className="sp-adcard__header">
                                        <i className="uil uil-map-marker"></i>
                                        <h3 className="sp-adcard__name" translate="no">{dir.name}</h3>
                                      </div>

                                      <div className="sp-adcard__details">
                                        <div className="sp-adcard__row">
                                          <span className="sp-adcard__label">Coordenadas:</span>
                                          <span className="sp-adcard__val" translate="no">Lat: {dir.lat}, Lng: {dir.lng}</span>
                                        </div>
                                        <div className="sp-adcard__row">
                                          <span className="sp-adcard__label">Teléfono:</span>
                                          <span className="sp-adcard__val" translate="no">{dir.phone}</span>
                                        </div>
                                        <div className="sp-adcard__row">
                                          <span className="sp-adcard__label">Número:</span>
                                          <span className="sp-adcard__val" translate="no">{dir.house_num}</span>
                                        </div>
                                        <div className="sp-adcard__row">
                                          <span className="sp-adcard__label">Referencias:</span>
                                          <span className="sp-adcard__val" translate="no">{dir.additional_info}</span>
                                        </div>

                                        <div className="sp-adcard__default">
                                          {dir?.is_default === 1 ? (
                                            <span className="sp-adcard__badge"><i className="uil uil-star"></i> Dirección predeterminada</span>
                                          ) : (
                                            <button
                                              className="sp-cbtn sp-cbtn--sm"
                                              onClick={(e) => {
                                                e.stopPropagation(); // Evita que se seleccione la card al hacer clic
                                                updateClientAddress(dir.id, dir);
                                              }}
                                            >
                                              Asignar predeterminado
                                            </button>
                                          )}
                                        </div>
                                      </div>

                                      {!isSelected && (
                                        <div className="sp-adcard__actions">
                                          <button
                                            className="sp-adcard__del"
                                            onClick={(e) => {
                                              e.stopPropagation(); // Evita que se seleccione la card al hacer clic en eliminar
                                              deleteClientAddress(dir.id);
                                            }}
                                          >
                                            <i className="uil uil-trash-alt"></i> Eliminar
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}

                              {address.length === 0 && (
                                <div className="sp-ad__empty"><i className="uil uil-location-point"></i> No hay direcciones guardadas</div>
                              )}
                            </div>
                          </>
                        ) : (
                          /* Formulario para agregar dirección — intacto */
                          <>
                            <NewAddressForm
                              setStatuslayout={setShowAddAddress}
                              getAddressClientNow={getAddressClientNow}
                              client_id={dataClientSelected.id}
                              phoneClient={dataClientSelected?.phone}
                            ></NewAddressForm>
                          </>
                        )}
                      </div>
                    )}
                  </>
                )}

              </div>
            </div>

            {/* ===== FOOTER ===== */}
            <div className="sp-cmodal__foot">
              <button type="button" className="sp-cbtn sp-cbtn--primary" onClick={handleCloseModal}>
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}



    </div>
  );
}